<template>
  <v-footer color="white" class="text-center mt-8">
    <v-col class="py-0" cols="12">
      <v-card flat tile color="white">
        <v-card-text class="py-1 info--text">
          IMPORTANT: Access to this system is restricted and protected by laws of the
          United States.
          Any unauthorized use of this system will be vigorously prosecuted.
          The IP addresses of users attempting to access this system are recorded.
          <a href="javascript:;"
             @click.stop="termsdialogIsVisible = true">Privacy Policy &amp; Terms of Use</a> |
          <a href="javascript:;"
            @click.stop="helpdialogIsVisible = true">Help</a>
          <terms-dialog v-model="termsdialogIsVisible" hide-buttons/>
          <help-dialog v-model="helpdialogIsVisible"/>
        </v-card-text>
        <v-divider/>
        <v-card-text class="py-1 text-center info--text">
          &copy; {{ new Date().getFullYear() }}
          F&amp;I Sentinel, LLC, All Rights Reserved.
        </v-card-text>
      </v-card>
    </v-col>
  </v-footer>
</template>

<script>
import termsDialog from './terms-conditions/terms-dialog';
import helpDialog from './help/help-dialog';

export default {
  components: {
    termsDialog,
    helpDialog,
  },
  data: () => ({
    termsdialogIsVisible: false,
    helpdialogIsVisible: false,
  }),
};
</script>
